import angular from 'angular';
import { ConfirmDeleteModal } from '~/utils/modals';
import APIV5 from '~/models/api';

/* globals Knitiv */

export default class {
	/* @ngInject */
	/**
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {Knitiv.Scope & *} $scope
	 * @param {import('angular').IQService} $q
	 * @param {import('angular').ILocationService} $location
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {*} NodeService
	 * @param {*} Template
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	constructor(
		$rootScope,
		$scope,
		$q,
		$location,
		$uibModal,
		NodeService,
		Template,
		$injector,
	) {
		$scope.templates = [];

		// Functions
		$scope.goToEditTemplatePage = (/** @type {any} */ item) => $location.path(`/export-template/new?kid=${item.kid}`);

		$scope.listTemplates = () => {
			APIV5.instance.objectList({ classKid: 'K_NODE;KEXPTPLT' }, { id: 'template-export.list-templates' })
				.then(data => {
					$scope.templates = data.list;
					return true;
				})
				.catch(error => {
					console.error('error', error);
				});
		};

		$scope.deleteTemplate = async (
			/** @type {any} */ event,
			/** @type {any} */ kid,
			/** @type {any} */ query,
		) => {
			event.preventDefault();

			const modal = new ConfirmDeleteModal($injector);
			const answer = await modal.open(query.repre_all['K_NODE;UNIVERSEL'].name);

			if (answer) {
				NodeService
					.delete(kid)
					.then($scope.listTemplates)
					.catch(() => {
						angular.element(event.target).closest('.list-group-item').blur();
					});
			}
		};

		// End functions

		// Start
		$scope.listTemplates();
	}
}
